import {common, promoPage} from "./common/common";
import JsUtil from "./util/js-util";
window.jsUtil = new JsUtil();

// jsUtil.status(".challenge__btn-reward", "disabled");
// jsUtil.status(".challenge__mission", "complete");
// jsUtil.status(".cases__btn--select", "disabled");
// jsUtil.status(".challenge__list--2 .challenge__mission", "remove");
// jsUtil.status(".challenge__list--2 .challenge__btn-reward", "remove");
//
// jsUtil.msgCallBack = (str)=>{
//     console.log(str)
// };
//
// $(".cases__btn--select").on("click", function(){
//     jsUtil.message("본인 확인이 필요합니다.", "realName");
// });
//
// $(".challenge__btn-reward").on("click", function(){
//     jsUtil.message("보상", "reward");
// });
// jsUtil.confirmCallBack = (str, status)=>{
//     console.log(str, status)
// };
//
// $(".cases__btn--select").on("click", function(){
//     jsUtil.confirm("대표 캐릭터는 변경이 불가능합니다.\n 해당 캐릭터를 선택하시겠습니까?", "selected");
// });

window.selectBox = promokit.select({
    el:'#select-box',
    options:[
        {value:1, label:'닉네임최대열글자이다 | 이스라펠 | Lv. 46 | 천족 | 마도성1'},
        // {value:2, label:'닉네임최대열글자이다 | 이스라펠 | Lv. 1 | 마족 | 마도성2'},
        // {value:3, label:'닉네임최대열글자이다 | 이스라펠 | Lv. 59 | 천족 | 마도성3'},
        // {value:4, label:'닉네임최대열글자이다 | 이스라펠 | Lv. 99 | 마족 | 마도성4'},
        // {value:5, label:'닉네임최대열글자이다 | 이스라펠 | Lv. 7 | 천족 | 마도성5'},
        // {value:6, label:'닉네임최대열글자이다 | 이스라펠 | Lv. 16 | 마족 | 마도성6'},
    ],
    // disabled:true,
    // selected:1,
    placeholder:'참여할 대표 캐릭터를 선택해 주세요.'
});

common();
promoPage();